module.exports = __webpack_public_path__ + "static/img/GW.92d3a388.svg";